var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 19,
    viewBox: "0 0 24 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.4 19C1.74 19 1.1752 18.7676 0.7056 18.3029C0.236 17.8382 0.0008 17.2789 0 16.625V2.375C0 1.72187 0.2352 1.16296 0.7056 0.69825C1.176 0.233541 1.7408 0.000791667 2.4 0H8.61C8.93 0 9.2352 0.0593751 9.5256 0.178125C9.816 0.296875 10.0708 0.465104 10.29 0.682812L12 2.375H21.6C22.26 2.375 22.8252 2.60775 23.2956 3.07325C23.766 3.53875 24.0008 4.09767 24 4.75V16.625C24 17.2781 23.7652 17.8374 23.2956 18.3029C22.826 18.7684 22.2608 19.0008 21.6 19H2.4ZM2.4 16.625H21.6V4.75H11.01L8.61 2.375H2.4V16.625ZM12 15.4375C12.34 15.4375 12.6252 15.3235 12.8556 15.0955C13.086 14.8675 13.2008 14.5857 13.2 14.25V10.45L14.28 11.5187C14.5 11.7365 14.78 11.8453 15.12 11.8453C15.46 11.8453 15.74 11.7365 15.96 11.5187C16.18 11.301 16.29 11.024 16.29 10.6875C16.29 10.351 16.18 10.074 15.96 9.85625L12.84 6.76875C12.6 6.53125 12.32 6.4125 12 6.4125C11.68 6.4125 11.4 6.53125 11.16 6.76875L8.04 9.85625C7.82 10.074 7.71 10.351 7.71 10.6875C7.71 11.024 7.82 11.301 8.04 11.5187C8.26 11.7365 8.54 11.8453 8.88 11.8453C9.22 11.8453 9.5 11.7365 9.72 11.5187L10.8 10.45V14.25C10.8 14.5865 10.9152 14.8687 11.1456 15.0967C11.376 15.3247 11.6608 15.4383 12 15.4375Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.9d98100e1d2e52f56ef37e4b21774b04.svg";
export { ForwardRef as ReactComponent };